import { IconProps } from 'src/utils/icon';

const ArrowDownIcon: React.FC<IconProps> = ({ size = 1, fill = '#2C2A29' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L8 8L14 2"
      stroke={fill}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDownIcon;
